import React, { useEffect, useState } from 'react';
import { Row, Col, Spinner } from 'react-bootstrap';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import snakecaseKeys from 'snakecase-keys';
import { Form, Formik } from 'formik';
import camelCaseRecursive from 'camelcase-keys-recursive';
import WorkerData from './Form/WorkerData';
import './styles/styles.css';
import { showSettlementRequest, calculateSettlementRequest } from '../../requests/payrollSettlements';
import CurrentTitleTab from './Tabs/CurrentTitleTab';
import validationSchema from './Form/ValidationSchema';
import initialValues from './Form/InitialValues';
import { prepareBalancesToSave } from './helpers';
import { Loader, SimpleCenteredModal } from '../../components';
import Filters from './Filters';

function NewSimulation() {
  const settlementState = JSON.parse(localStorage.getItem('settlementForm'));
  const [settlement, setSettlement] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [simpleModalShow, setSimpleModalShow] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { id: settlementID } = useParams();
  const { currentCompany } = useSelector(state => state.auth);

  const fetchSettlement = async () => {
    setIsLoading(true);
    if (settlementID && !settlementState) {
      showSettlementRequest(settlementID, {
        dispatch,
        params: {
          form_serializer: true
        },
        successCallback: ({ data }) => {
          setSettlement(camelCaseRecursive(data));
        },
        callback: () => {
          setIsLoading(false);
        }
      });
      return;
    }
    setIsLoading(false);
    if (settlementState) {
      setSettlement(settlementState);
      return;
    }
    setSettlement({});
  };

  const formRequest = (values, { setSubmitting }) => {
    setSimpleModalShow(true);
    const newValues = prepareBalancesToSave(values);
    const requestParams = {
      dispatch,
      params: {
        settlement: {
          ...snakecaseKeys(newValues, { exclude: ['_destroy'] }),
          company_id: currentCompany.id
        }
      },
      successCallback: ({ data }) => {
        setSubmitting(false);
        setSimpleModalShow(false);
        localStorage.setItem('settlementForm', JSON.stringify(camelCaseRecursive(data)));
        history.push(`/settlement_simulator/summary`);
      },
      callBack: () => {
        setSimpleModalShow(false);
        setSubmitting(false);
      }
    };
    calculateSettlementRequest(requestParams);
  };

  const handleCompanyChange = () => {
    if (!currentCompany?.id) return;
    fetchSettlement();
  };

  useEffect(handleCompanyChange, [currentCompany]);
  return (
    <Col style={{ backgroundColor: '#f5f5f5', marginTop: 35 }} xl={12}>
      <Row>
        <Filters />
      </Row>
      {isLoading && (
        <div className="containerSpinnerLoad h-100 w-100">
          <Spinner animation="border" variant="primary" />
        </div>
      )}
      {settlement && !isLoading && (
        <Formik
          initialValues={initialValues(settlement)}
          validationSchema={validationSchema}
          onSubmit={(values, formikBag) => formRequest(values, formikBag)}
          enableReinitialize
        >
          <Form>
            <CurrentTitleTab title="DATOS DEL TRABAJADOR" />
            <Row>
              <Col style={{ padding: 10 }}>
                <WorkerData companyID={currentCompany.id} settlementID={settlementID} />
              </Col>
            </Row>
          </Form>
        </Formik>
      )}
      <SimpleCenteredModal
        title="Generando finiquito"
        body={<Loader message="Estamos procesando su solicitud, por favor espera unos segundos." />}
        show={simpleModalShow}
        onHide={() => setSimpleModalShow(false)}
        bodyClass="mx-3 mb-3"
        size="md"
        closeButton={false}
      />
    </Col>
  );
}

const mapStateToProps = state => ({ settlementStages: state.utils.settlementStages });

export default connect(mapStateToProps)(NewSimulation);
